<!-- Security - SAML options -->
<form #samlForm="ngForm" class="mt-20">
  <div class="form saml-config-dialog">
    <div class="security-category">
      <h5>{{locale.LABEL_SERVICEPROVIDER_INFO}}</h5>

      <p> {{locale.LABEL_HELP_SAML_SERVICE_PROVIDER_INFO}} </p>
      <!-- metadata url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3"
          for="wm-security-saml-sp-metadata-url">{{locale.LABEL_SAML_METADATA_URL}}: </label>
        <div class="col-xs-9">
          <div class="input-group wm-security-clipboard">
            <input name="wm-security-saml-sp-metadata-url" type="text"
              class="form-control form-input-disabled clipboard-target" title={{security.spMetadataUrl}}
              value={{security.spMetadataUrl}} readonly />
            <span class="clipboard-button" (click)="copyToClipboard($event)" *ngIf="appRunUrl || isDeploying">
              <i title="{{locale.ICONTITLE_COPY_CLIPBOARD}}" class="wm-icon wms wms-content-copy"
                *ngIf="!isDeploying"></i>
              <i title="{{locale.ICONTITLE_LOADING_URL}}" class="wm-icon fa fa-circle-o-notch fa-spin"
                *ngIf="isDeploying"></i>
            </span>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_SP_METADATA}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>

      <!-- audience url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3"
          for="wm-security-saml-audience-url">{{locale.LABEL_SAML_SP_AUDIENCE_URL}}: </label>
        <div class="col-xs-9">
          <div class="input-group wm-security-clipboard">
            <input name="wm-security-saml-audience-url" type="text"
              class="form-control form-input-disabled clipboard-target" [(ngModel)]="security.audienceUrl" readonly />
            <span class="clipboard-button" (click)="copyToClipboard($event)">
              <i title="{{locale.ICONTITLE_COPY_CLIPBOARD}}" class="wm-icon wms wms-content-copy"></i>
            </span>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_AUDIENCE_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>

      <!-- single sign on  url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3" for="wm-security-saml-signon-url">{{locale.LABEL_SAML_SSO_URL}}:
        </label>
        <div class="col-xs-9">
          <div class="input-group wm-security-clipboard">
            <input name="wm-security-saml-signon-url" type="text"
              class="form-control form-input-disabled clipboard-target" [(ngModel)]="security.signonUrl" readonly />
            <span class="clipboard-button" (click)="copyToClipboard($event)">
              <i title="{{locale.ICONTITLE_COPY_CLIPBOARD}}" class="wm-icon wms wms-content-copy"></i>
            </span>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_SP_SSO_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>

      <!-- logout url -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3 "
          for="wm-security-saml-signout-url">{{locale.LABEL_SAML_SLO_URL}}: </label>
        <div class="col-xs-9">
          <div class="input-group wm-security-clipboard">
            <input name="wm-security-saml-signout-url" type="text"
              class="form-control form-input-disabled clipboard-target" [(ngModel)]="security.signoutUrl" readonly />
            <span class="clipboard-button" (click)="copyToClipboard($event)">
              <i title="{{locale.ICONTITLE_COPY_CLIPBOARD}}" class="wm-icon wms wms-content-copy"></i>
            </span>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_SP_SLO_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <hr>
    </div>

    <div class="security-category">
      <h5>{{locale.LABEL_SAML_IDP}}</h5>

      <p> {{locale.LABEL_HELP_SAML_IDP_CONFIG}}</p>

      <!-- Metadata Switch -->
      <div class="form-group app-composite-widget clearfix">
        <label class="control-label app-label col-xs-3"
          for="wm-security-saml-metadata">{{locale.LABEL_SAML_METADATA_SRC}}: </label>
        <div class="col-xs-9">
          <wms-toggle id="wm-security-saml-metadata" class="metadata-switch col-xs-3 pl-0" name="wm-role-config-wm-security-saml-metadata"
            [model]="security.idpMetadataSource" [onLabel]="'URL'" [offLabel]="'FILE'" [onValue]="'URL'" [offValue]="'FILE'" customClasses="switch"
            (onChange)="security.idpMetadataSource = $event === true ? 'URL' : 'FILE'; isLoading = false; securityService.hideMsg= true;"></wms-toggle>

          <!-- Metadata File Upload -->
          <div class="inline-fields col-xs-8 fileupload-url-content"
            *ngIf="security.idpMetadataSource === security.metadataSrcOptionsMap.FILE">
            <label class="control-label app-label col-xs-5 required inline-label"
              for="wm-security-saml-metadata-file">{{locale.LABEL_SAML_SP_UPLOAD_METADATA_FILE}}: </label>
            <div class="col-xs-7">
              <div *ngIf="security.metadataFileName">
                <i class="wms wms-file-text fa-lg"></i>
                <a class="file-link" (click)="execOpenFile(securityService.METADATA_FILE_PATH, securityService.METADATA_FILE_NAME)"
                  id="wm-security-saml-metadata-file-name">{{security.metadataFileName}}</a>
                <i class="wms wms-clear" (click)="security.metadataFileName = '';"
                  title="{{locale.LABEL_HELP_SAML_REMOVE_FILE}}"> </i>
              </div>
              <div *ngIf="!security.metadataFileName">
                <div class="form-upload">
                  <input *ngIf="!isLoading" id="wm-security-saml-metadata-file" type="file" name="metadata-file"
                    accept=".xml" class="wm-file-uploader" (change)="uploadMetadataFile()" />
                  <span *ngIf="isLoading">
                    <i class="fa fa-circle-o-notch fa-spin"></i> {{locale.MESSAGE_SAML_VALIDATING_METADATA_FILE}}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Idp Metadata URL -->
          <div class="col-xs-8 fileupload-url-content"
            *ngIf="security.idpMetadataSource === security.metadataSrcOptionsMap.URL">
            <div class="col-xs-10">
              <div class="wm-idp-url">
                <input name="wm-security-saml-idp-metadata" type="text" placeholder={{security.placeholder.SAML_metadata}}
                  class="form-control app-textbox  full-width" (change)="setMetaUrlDirty();"
                  [(ngModel)]="security.idpMetadataUrl" (ngModelOptions)="{'updateOn' : 'blur'}" />
                <span class="input-group-addon" *ngIf="isLoading">
                  <i class="fa fa-circle-o-notch fa-spin"></i>
                </span>
              </div>
            </div>
            <div class="col-xs-2">
              <button name="wm-security-load" class="button-primary inline-button"
                (click)="validateIdpUrl()">{{locale.LABEL_LOAD}}</button>
            </div>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_METADATA}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>

      <!-- endpoint url -->
      <div class="form-group app-composite-widget clearfix" *ngIf="isMetadataLoaded">
        <label class="control-label app-label col-xs-3"
          for="wm-security-saml-endpoint-url">{{locale.LABEL_SAML_END_POINT_URL}}: </label>
        <div class="col-xs-9">
          <div class="input-group wm-security-clipboard">
            <input type="text" name="wm-security-saml-endpoint-url"
              class="form-control form-input-disabled clipboard-target" [(ngModel)]="security.idpEndpointUrl"
              readonly />
            <span class="clipboard-button" (click)="copyToClipboard($event)"><i
                title="{{locale.ICONTITLE_COPY_CLIPBOARD}}" class="wm-icon wms wms-content-copy"></i></span>
          </div>
          <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_END_POINT_URL}}"
            class="wm-icon wms wms-help ml-5"></i>
        </div>
      </div>
      <hr>
    </div>

    <div *ngIf="isMetadataLoaded">

      <div class="security-category">
        <!-- Service Provider (Application) -->
        <h5>{{locale.LABEL_SERVICEPROVIDER}}</h5>

        <p> {{locale.LABEL_HELP_SAML_SERVICE_PROVIDER}} </p>

        <!-- Switch -->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3 "
            for="wm-security-saml-keyStore">{{locale.LABEL_SAML_KEYSTORE}}: </label>
          <div class="col-xs-9">
            <wms-toggle *ngIf="!security.keyStoreName" id="wm-security-saml-keyStore"
              class="form-group pl-0" name="wm-role-config-wm-security-saml-keyStore" [model]="security.keyStoreValue"
              [onLabel]="'Auto Generate'" [offLabel]="'Import'" [offValue]="'IMPORT'" [onValue]="'AUTO GENERATE'" customClasses="switch"
              (onChange)="security.keyStoreValue = $event === true ? 'AUTO GENERATE' : 'IMPORT'; isLoading = false;"></wms-toggle>

            <div class="inline-fields col-xs-11 pl-0"
              *ngIf="security.keyStoreValue === security.keyStoreOptions[1] && !security.keyStoreName">
              <label class="col-xs-5 pl-0" for="wm-security-saml-jks-file">{{locale.LABEL_SAML_UPLOAD}}:</label>
              <div class="col-xs-7">
                <input id="wm-security-saml-jks-file" type="file" name="jks-file" accept=".jks" class="wm-file-uploader"
                  (change)="uploadJksFile()" />
              </div>
            </div>
            <div class="col-xs-11 pl-0" *ngIf="security.keyStoreName">
              <i class="wms wms-file-text fa-lg"></i>
              <a class="file-link" (click)="execOpenFile(JKS_FILE_PATH, security.keyStoreName)"
                id="wm-security-saml-file-name">{{security.keyStoreName}}</a>
              <i class="wms wms-clear" (click)="resetKeystoreOptions()" title="{{locale.LABEL_HELP_SAML_REMOVE_FILE}}">
              </i>
            </div>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_KEYSTORE}}"
              class="wm-icon wms wms-help ml-5"></i>
          </div>
        </div>

        <!-- alias -->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3 required"
            for="wm-security-saml-alias">{{locale.LABEL_SAML_ALIAS}}: </label>

          <div class="col-xs-9">
            <input name="wm-security-saml-alias" type="text" class="form-control app-textbox"
              [(ngModel)]="security.keyAlias" autocomplete="off" />
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_ALIAS}}"
              class="wm-icon wms wms-help ml-5"></i>
          </div>
        </div>

        <!-- password -->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3 required"
            for="wm-security-saml-password">{{locale.LABEL_SAML_PASSWORD}}: </label>

          <div class="col-xs-9">
            <input name="wm-security-saml-password" type="password" class="form-control app-textbox"
              [(ngModel)]="security.keyStorePassword" autocomplete="off" />
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_PASSWORD}}"
              class="wm-icon wms wms-help ml-5"></i>
          </div>
        </div>

        <!-- subject name -->
        <div class="form-group app-composite-widget clearfix"
          *ngIf="security.keyStoreValue === security.keyStoreOptions[0]">
          <label class="control-label app-label col-xs-3 required"
            for="wm-security-saml-subject-name">{{locale.LABEL_SAML_SUBJECT }}: </label>

          <div class="col-xs-9">
            <textarea name="wm-security-saml-subject-name" class="form-control security-description"
              [(ngModel)]="security.subjectName" (ngModelOptions)="{'updateOn' : 'blur'}">{{security.subjectName}}</textarea>
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_SUBJECT_NAME}}"
              class="wm-icon wms wms-help ml-5"></i>
          </div>
        </div>

        <!-- Max Authentication Age-->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3"
            for="wm-security-saml-max-auth-age">{{locale.LABEL_SAML_MAX_AUTH_AGE}}: </label>

          <div class="col-xs-9">
            <input name="wm-security-saml-max-auth-age" type="number" class="login-widget form-control app-textbox"
              [(ngModel)]="security.maxAuthenticationAge" autocomplete="off"
              placeholder={{locale.LABEL_SAML_PLACEHOLDER_MAX_AUTH_AGE}} />
            <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_MAX_AUTH_AGE}}"
              class="wm-icon wms wms-help ml-5"></i>
          </div>
        </div>
        <hr>
      </div>

      <div class="security-category">
        <h5>{{locale.LABEL_ROLE}}</h5>

        <!-- Enable Role Mapping-->
        <div class="form-group app-composite-widget clearfix">
          <label class="control-label app-label col-xs-3">{{locale.LABEL_SEARCH_USER_ROLE}}: </label>
          <div class="col-xs-9">
            <wms-toggle id="wm-security-saml-user-roles-toggle" class="metadata-switch switch" name="wm-role-config-wm-security-saml-user-roles-toggle"
              [model]="security.roleMappingEnabled" [onLabel]="'On'" [offLabel]="'Off'"
              (onChange)="security.roleMappingEnabled = $event;"></wms-toggle>
          </div>
        </div>

        <!-- Search User Role Options-->
        <div *ngIf="security.roleMappingEnabled">
          <div class="form-group app-composite-widget clearfix">
            <label class="control-label app-label col-xs-3"
              for="wm-sec-saml-select-search-user-role-provider">{{locale.LABEL_SELECT_USER_ROLE_PROVIDER}}: </label>
            <div class="col-xs-9">
              <select name="wm-sec-saml-select-search-user-role-provider" class="form-control app-select"
                [(ngModel)]="security.roleProvider">
                <option *ngFor="let option of security.userSAMLRoleProviders">{{option}}</option>
              </select>
              <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_HELP_SAML_ROLE_PROVIDER}}"
                class="wm-icon wms wms-help ml-5"></i>


            </div>
          </div>

          <div [ngSwitch]="security.roleProvider">
            <div *ngSwitchCase="'SAML'">
              <div class="form-group app-composite-widget clearfix">
                <label class="control-label app-label col-xs-3 required"
                  for="wm-sec-saml-grp-search-base">{{locale.LABEL_ROLE_ATTRIBUTE_NAME}}: </label>
                <div class="col-xs-9">
                  <input name="wm-sec-saml-grp-search-base" type="text" class="form-control app-textbox"
                    [(ngModel)]="security.roleAttributeName" (ngModelOptions)="{'updateOn' : 'blur'}" />
                  <i placement="right" [tooltipAppendToBody]="true"
                    tooltip="{{locale.LABEL_HELP_SAML_ROLE_ATTRIBUTE_NAME}}" class="wm-icon wms wms-help ml-5"></i>
                </div>
              </div>
            </div>
            <div class="security-sub-category" *ngSwitchCase="'Database'">
              <!-- Roles By SQL Query -->
              <wms-database [securityProps]="securityProps" [authInfo]="authInfo"></wms-database>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>